import { Pagination } from '~/composables'

export function preparedGtagIndex (index: number, pagination: Pagination): number {
  if (!pagination) return index
  return index + pagination.itemsPerPage * (pagination.currentPage - 1)
}
